import type { ReactNode } from 'react';
import { ChatContentLayout } from '../chat-content-layout';
import { ChatroomSidebar, ChatroomSidebarContent } from '../chatroom-sidebar';
import type { ChatroomsSearchParamsOptions } from '../types';

type P = {
  children: ReactNode;
  onChatDeleted: () => Promise<void>;
  onChatRoomClicked: (id: string) => Promise<void>;
  onCreateChatClicked: () => Promise<void>;
  searchParamsOptions: ChatroomsSearchParamsOptions;
};

const ChatCreateLayout = ({
  children,
  onChatDeleted,
  onChatRoomClicked,
  onCreateChatClicked,
  searchParamsOptions,
}: P) => (
  <ChatContentLayout
    left={
      <ChatroomSidebar onCreateChatClicked={onCreateChatClicked} searchParamsOptions={searchParamsOptions}>
        {({ filter }) => (
          <ChatroomSidebarContent
            filter={filter}
            onChatDeleted={onChatDeleted}
            onChatRoomClicked={onChatRoomClicked}
            onCreateChatClicked={onCreateChatClicked}
          />
        )}
      </ChatroomSidebar>
    }
    right={children}
  />
);

export default ChatCreateLayout;
